import { Box, Typography } from "@mui/material";

const TrackerPageHeader = ({ title, description, children }) => (
    <Box
        sx={{
            width: "100%",
            px: 2,
            py: 1.75,
            backgroundColor: "#FFFFFF",
            borderBottom: "1px solid #E2E8F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
        }}
    >
        <Box sx={{ minWidth: 0 }}>
            <Typography
                sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "20px",
                    lineHeight: "27px",
                    fontWeight: 650,
                    color: "#0F172A",
                }}
            >
                {title}
            </Typography>
            <Typography
                sx={{
                    mt: 0.25,
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "12px",
                    lineHeight: "17px",
                    fontWeight: 400,
                    color: "#64748B",
                }}
            >
                {description}
            </Typography>
        </Box>
        {children && <Box sx={{ flexShrink: 0 }}>{children}</Box>}
    </Box>
);

export default TrackerPageHeader;
